import { createWebHistory, createRouter } from 'vue-router'

import HomeView from './views/Home.vue'
import GameView from './views/Game.vue'
import LoginView from './views/Login.vue'
import BattleReport from "./views/BattleReport.vue";
const routes = [
  { path: '/', component: HomeView, meta: { inGame: false } },
  { path: '/login', component: LoginView, meta: { inGame: false } },
  { path: '/game', component: GameView, meta: { inGame: true } },
  { path: '/battle-report/:id', component: BattleReport, meta: { standalone: true } },
];

export const router = createRouter({
  history: createWebHistory('./'),
  routes,
})